module.exports = __webpack_public_path__ + "img/austria.d2bb0026.svg";